import React, { useEffect, useState } from 'react';
import { RichText, Text, Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const WhyLifeInsurance = (props) => {
  const [videoSrc, setVideoSrc] = useState('');
  useEffect(() => {
    const handleVideoClick = (button) => {
      setVideoSrc(button.getAttribute('data-src'));
    };

    const videoPlayButtons = document.querySelectorAll('.video-play-button');
    videoPlayButtons.forEach((button) => {
      button.addEventListener('click', () => handleVideoClick(button));
    });

    return () => {
      videoPlayButtons.forEach((button) => {
        button.removeEventListener('click', () => handleVideoClick(button));
      });
    };
  }, []);

  useEffect(() => {
    const videoModal = document.querySelector('#video-modal');
    if (videoModal) {
      videoModal.addEventListener('shown.bs.modal', () => {
        const video = document.querySelector('#video');
        if (video) {
          video.setAttribute('src', videoSrc);
        }
      });

      videoModal.addEventListener('hide.bs.modal', () => {
        const video = document.querySelector('#video');
        if (video) {
          video.setAttribute('src', videoSrc);
        }
      });

      return () => {
        videoModal.removeEventListener('shown.bs.modal', () => {
          const video = document.querySelector('#video');
          if (video) {
            video.setAttribute('src', videoSrc);
          }
        });

        videoModal.removeEventListener('hide.bs.modal', () => {
          const video = document.querySelector('#video');
          if (video) {
            video.setAttribute('src', videoSrc);
          }
        });
      };
    }
  }, [videoSrc]);

  useEffect(() => {
    const topBenefitsSwiper = new Swiper('.topBenefits-slider', {
      slidesPerView: 4,
      spaceBetween: 40,
      freeMode: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        420: {
          slidesPerView: 2.6,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });

    return () => {
      topBenefitsSwiper.destroy();
    };
  }, []);

  useEffect(() => {
    var whydoyouneedSwiper = new Swiper('.whydoyouneed-slider', {
      slidesPerView: 6,
      spaceBetween: 20,
      freeMode: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
        },
        420: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      },
    });

    return () => {
      whydoyouneedSwiper.destroy();
    };
  }, []);

  const backgroundImageStyle = props?.fields?.data?.lifeIns?.sectionBG?.src
    ? {
        background: `url(${props?.fields?.data?.lifeIns.sectionBG.src})`,
        backgroundSize: 'cover',
      }
    : {};
  const hasTopBenefits = props?.fields?.data?.lifeIns?.topBenefitsFolder?.targetItem?.top_benefits;
  const topBenefitsVisibility = hasTopBenefits && hasTopBenefits.length > 0 ? '' : 'hide';
  const showRightSideContent = props?.params?.showRightSideContent;
  return (
    <>
      <section
        className={`what_is_life_insurance our_life_insurance_plans_cat_page ${
          showRightSideContent === 'true' || showRightSideContent === undefined
            ? ''
            : 'why_you_need_li_sub_cat improve-credit-score-sec'
        }`}
        id={props?.fields?.data?.lifeIns?.stickyNavId?.value}
        style={backgroundImageStyle}
      >
        {showRightSideContent === 'true' || showRightSideContent === undefined ? (
          <div className="content_container">
            <div className="content_left_container">
              <RichText
                tag="h2"
                className="section-heading heading-flex"
                field={props?.fields?.data?.lifeIns?.heading}
                editable
              />
              <RichText tag="p" field={props?.fields?.data?.lifeIns?.subHeading} editable />
            </div>
            <div className="content_right_container">
              {props?.fields?.data?.lifeIns?.backgroundImage?.src && (
                <div className="watch_video_wrapper">
                  <picture>
                    <Image
                      field={props?.fields?.data?.lifeIns?.backgroundImage}
                      alt="img"
                      width="100%"
                      height="100%"
                      className="watch_video_poster"
                      editable
                      loading="lazy"
                    />
                  </picture>
                  <a
                    href="#"
                    className="video-play-button"
                    id="play-video"
                    data-bs-toggle="modal"
                    data-bs-target="#video-modal"
                    onClick={() => setVideoSrc(props?.fields?.data?.lifeIns?.videoLink?.url)}
                  >
                    <Image
                      field={props?.fields?.data?.lifeIns?.image}
                      className="watch_video"
                      loading="lazy"
                    />
                    <span>
                      <Text field={props?.fields?.data?.lifeIns?.videoText} />
                    </span>
                  </a>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="content_container-fluid text-center">
            <div className="content_left_container">
              <RichText
                tag="h2"
                className="section-heading heading-flex"
                field={props?.fields?.data?.lifeIns?.heading}
                editable
              />
              <RichText tag="p" field={props?.fields?.data?.lifeIns?.subHeading} editable />
            </div>
          </div>
        )}

        <div className={`topBenefits-div ${topBenefitsVisibility}`}>
          <div className="topBenifits-heading">
            <RichText
              tag="h3"
              className="heading-tb"
              field={props?.fields?.data?.lifeIns?.topBenefitsHeading}
              editable
            />
          </div>
          <div
            className={`swiper  ${
              showRightSideContent === 'true' || showRightSideContent === undefined
                ? 'topBenefits-slider'
                : 'whydoyouneed-slider'
            }`}
          >
            <div className="swiper-wrapper features_ben_grid_wrapper dflex-imp">
              {props?.fields?.data?.lifeIns?.topBenefitsFolder?.targetItem?.top_benefits.map(
                (card, index) => (
                  <div key={index} className="swiper-slide">
                    <div className="features_ben_boxes">
                      <Image field={card?.image} width="100%" height="100%" loading="lazy" />
                      <div className="features_ben_text">
                        <RichText tag="h4" className="features_ben_text_headig_35fxvr" field={card?.heading} editable />
                        <p>
                          <Text field={card?.description} editable />
                        </p>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>
      <div
        className="modal fade video_modal_sec_2"
        id="video-modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="video-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body popup__overlay">
              <iframe
                width="100%"
                height="100%"
                src={videoSrc}
                id="video"
                frameBorder="0"
                allow="autoplay"
                allowFullScreen
                title="Embedded Video"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(WhyLifeInsurance);
